export default __webpack_public_path__ + "locales/fr/FilesSettings.json?hash=cf6f8b3b6960655d3ccb85dee7ba2aff";